import React from "react";
import { Link } from "react-router-dom";
import { colors, typography, surfaces } from "../styles/index";

// PLACEHOLDER - the copy from logistics-workflow was FreightPeace's own legal text. Replace this with reviewed terms of service before
// the app takes real customers.
export default function TermsPage() {
  return (
    <div style={{ minHeight: "100vh", background: colors.bgSoft, padding: "48px 24px" }}>
      <div style={{ ...surfaces.card, maxWidth: 760, margin: "0 auto" }}>
        <h1 style={{ ...typography.h2, marginBottom: 12 }}>Terms of Service</h1>
        <p style={{ ...typography.body, color: colors.text }}>
          These terms are being written. SimulateJob turns an organization's procedures into training games for its own people; each organization owns the documents it uploads and the games it makes.
        </p>
        <p style={{ ...typography.small, color: colors.textMuted }}>Draft - to be replaced before launch.</p>
        <Link to="/">Back to SimulateJob</Link>
      </div>
    </div>
  );
}
